import { makeGetCall } from 'frontend/core/src/data/util';
import { hostUrl } from 'frontend/core/src/utils/getServerUrl';

/**
 * Verify the payment status for a session
 * @param sessionId - The ID of the session to verify
 * @returns The payment status for the session
 */
export const verifyPaymentStatus = async (sessionId: string) => {
  return makeGetCall(`${hostUrl}/api/payments/checkout?sessionId=${sessionId}`, {});
};

/**
 * Get the customer balance for the team. This includes the outstanding balance, credit balance, credits breakdown, service credits consumed, and user credits consumed.
 * @param userId - The ID of the user to get the customer balance for
 * @param teamId - The ID of the team to get the customer balance for
 * @returns
 */
export const getCustomerBalance = async (userId: string, teamId: string) => {
  return makeGetCall(`${hostUrl}/api/payments/customerBalance?userId=${userId}&teamId=${teamId}`);
};

export const getProfessionalMeteringInfo = async (teamId: string) => {
  return makeGetCall(`${hostUrl}/api/professional/metering/${teamId}`);
};

// The Free trial is set for a cluster and not for a team
export const getProfessionalFreeTrialInfo = async () => {
  return makeGetCall(`${hostUrl}/api/professional/freeTrial`);
};
